import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { state } = useAuth();
  // If there's no token, redirect to the login page
  if (!state.token) {
    return <Navigate to="/login" replace />;
  }
  // Otherwise, render the children (the protected component)
  return children;
};

export default ProtectedRoute;
